/**
 * HE.CustomConfirm v2
 * https://confluence.cruiseplannersnet.com/display/AP/Utlizing+Custom+Confirms
 */

(function CustomConfirm($, HE)
{
	"use strict";

	var defaults = {
		body            : 'Are you sure you wish to continue?',
		title           : 'Decision Time',
		icon            : HE.FaIcon.getIconStyle('info_circle'),
		confirm_btn_text: 'Yes',
		cancel_btn_text : 'No',
		close_icon      : false,

		// uncommon jconfirm option override ability
		animation         : 'opacity',
		animateFromElement: false,
		backgroundDismiss : false,
		theme             : 'bootstrap',
	};

	var confirm = function confirm(opts)
	{
		var _opts;

		if (typeof opts !== 'object') {
			throw new Error('Expecting opts object, got ' + typeof opts);
		}

		_opts = $.extend({}, defaults, opts);

		if (opts.confirm && opts.url) {
			throw new Error('Cannot use confirm and url options together');
		}


		return $.confirm({
			// uncommon jconfirm option overrides
			animation         : _opts.animation || defaults.animation,
			animateFromElement: _opts.animateFromElement || defaults.animateFromElement,
			backgroundDismiss : _opts.backgroundDismiss || defaults.backgroundDismiss,
			theme             : _opts.theme || defaults.theme,

			// common overrides
			title    : _opts.title || defaults.title,
			content  : _opts.content || _opts.body || defaults.body,
			icon     : _opts.icon,
			closeIcon: _opts.close_icon,
			buttons  : {
				confirm: {
					text  : _opts.confirm_btn_text,
					action: function _confirmAction() {
						if (typeof _opts.confirm === 'function') {
							_opts.confirm();
						}
						else if (_opts.url) {
							if (_opts.url_new_tab) {
								window.open(_opts.url, '_blank');
							} else {
								window.location.href = _opts.url;
							}
						}
					}
				},
				cancel: {
					text  : _opts.cancel_btn_text,
					action: function _cancelAction() {
						if (typeof _opts.cancel === 'function') {
							_opts.cancel();
						}
					}
				},
			},
			onOpenBefore: function _applyHEStyle() {
				this.$body.addClass('he-status confirm');
			}
		});
	};

	// handle .confirm-link links
	// binding found in HE/_global.js
	confirm.link = function linkConfirm($link)
	{
		var opts = {
			title           : $link.data('confirm-title'),
			body            : $link.data('confirm-message'),
			confirm_btn_text: $link.data('ok-text'),
			cancel_btn_text : $link.data('cancel-text'),
			confirm         : function _linkConfirmed() {
				if ($link.data('new-tab') === undefined) {
					window.location.href = $link.attr('href');
				} else {
					window.open($link.attr('href'), '_blank');
				}
			}
		};

		if ($link.data('confirm-icon')) {
			opts.icon = HE.FaIcon.getIconStyle($link.data('confirm-icon'));
		}

		confirm(opts);
	};

	HE.CustomConfirm = confirm;
}(jQuery, window.HE || {}));
